import { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import useFormState from '../../../../shared/hooks/useFormState';

const tipoDatoOptions = [
    { label: 'CADENA', value: 'CADENA' },
    { label: 'ENTERO', value: 'ENTERO' },
];

export const AtributoFormDialog = ({ visible, onCancel, familia, atributo, onConfirm }) => {
    const isEdit = Boolean(atributo?.id);
    const { values, errors, handleChange, handleSelect, reset, validate } = useFormState(
        { llave: '', tipoDato: 'CADENA' },
        {
            llave: [(v) => (!v?.trim() ? 'La llave es requerida.' : null)],
        }
    );

    useEffect(() => {
        if (visible) {
            if (atributo) {
                reset({
                    llave: atributo.llave || atributo.nombre || '',
                    tipoDato: atributo.tipoDato || atributo.tipo_dato || 'CADENA',
                });
            } else {
                reset({ llave: '', tipoDato: 'CADENA' });
            }
        }
    }, [visible, atributo]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleCancel = () => {
        reset({ llave: '', tipoDato: 'CADENA' });
        onCancel();
    };

    const handleConfirm = () => {
        if (!validate()) return;
        if (onConfirm) {
            onConfirm({
                id: atributo?.id,
                familiaId: familia?.id,
                llave: values.llave.trim(),
                tipo_dato: values.tipoDato,
            });
        }
        handleCancel();
    };

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button className="p-button-text" label="Cancelar" onClick={handleCancel} />
            <Button className="p-button" label={isEdit ? "Guardar" : "Agregar"} disabled={!values.llave.trim()} onClick={handleConfirm} />
        </div>
    );

    return (
        <Dialog
            header={isEdit ? "Editar Atributo" : "Agregar Atributo"}
            visible={visible}
            onHide={handleCancel}
            footer={footer}
            style={{ width: '50vw' }}
        >
            <div className="flex flex-column gap-3">
                {!isEdit && (
                    <p className="m-0 text-sm text-500">
                        Familia: <strong>{familia?.name || familia?.nombre || ''}</strong>
                    </p>
                )}
                <div className="field">
                    <label htmlFor="llave-atributo" className="block font-medium mb-2">Llave del atributo</label>
                    <InputText
                        id="llave-atributo"
                        value={values.llave}
                        onChange={handleChange('llave')}
                        className={`w-full ${errors.llave ? 'p-invalid' : ''}`}
                        placeholder="Ej: COLOR"
                        maxLength={50}
                        autoFocus
                    />
                    {errors.llave && <small className="p-error">{errors.llave}</small>}
                </div>
                <div className="field">
                    <label htmlFor="tipo-dato-atributo" className="block font-medium mb-2">Tipo de dato</label>
                    <Dropdown
                        id="tipo-dato-atributo"
                        value={values.tipoDato}
                        options={tipoDatoOptions}
                        onChange={handleSelect('tipoDato')}
                        className="w-full"
                        placeholder="Selecciona un tipo"
                    />
                </div>
            </div>
        </Dialog>
    );
};